<template>
  <div>
    <page-header :title="$t('bill.bill_overview')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv">
      <template v-slot:title>
        <a-tooltip placement="left" :get-popup-container="getPopupContainer">
          <template slot="title">
            {{ $t('bill.report_sub') }}
          </template>
          <!-- <a-icon class="position-absolute" style="right: 0;" type="setting" @click="openBillReportSubDialog" /> -->
        </a-tooltip>
      </template>
      <div slot="res-status-tab">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <overview-index ref="overviewIndex" :cloud-env="cloudEnv" />
    </page-body>
  </div>
</template>

<script>
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import { getCloudEnvOptions } from '@/utils/common/hypervisor'
import WindowsMixin from '@/mixins/windows'
import OverviewIndex from './components/index'

export default {
  name: 'BillOverview',
  components: {
    OverviewIndex,
    BillConfig,
  },
  mixins: [WindowsMixin, shareMixin],
  data () {
    return {
      cloudEnvOptions: getCloudEnvOptions('brands'),
      cloudEnv: '',
      getPopupContainer (trigger) {
        return trigger.parentElement
      },
    }
  },
  methods: {
    openBillReportSubDialog () {
      this.createDialog('BillReportSubDialog', {})
    },
    currencyChange (val) {
      this.$refs.overviewIndex && this.$refs.overviewIndex.changeCurrency(val)
    },
  },
}
</script>
